export function getExtensionFromMimeType(mimetype: string): string {
  switch (mimetype) {
    case 'image/jpeg':
    case 'image/jpg':
      return 'JPG';
    case 'image/png':
      return 'PNG';
    case 'image/gif':
      return 'GIF';
    case 'image/webp':
      return 'WEBP';
    case 'image/heic':
      return 'HEIC';
    case 'image/heif':
      return 'HEIF';
    case 'application/pdf':
      return 'PDF';
    case 'application/msword':
      return 'DOC';
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'DOCX';
    case 'application/vnd.ms-excel':
      return 'XLS';
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'XLSX';
    case 'application/vnd.ms-powerpoint':
      return 'PPT';
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      return 'PPTX';
    case 'application/vnd.apple.keynote':
    case 'application/x-iwork-keynote-sffkey':
      return 'KEY';
    case 'text/plain':
      return 'TXT';
    case 'text/html':
      return 'HTML';
    default:
      return 'OTHER';
  }
}

export function isPresentationMimetype(mimetype: string): boolean {
  switch (mimetype) {
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    case 'application/vnd.ms-powerpoint':
    case 'application/vnd.apple.keynote':
    case 'application/vnd.google-apps.presentation':
    case 'application/x-iwork-keynote-sffkey':
      return true;
    default:
      return false;
  }
}

// for material attachments
export const SupportedMimeTypes = [
  'application/msword',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'text/html',
  'text/plain',
];

// for material attachments
export function isFileMimetypeSupported(mimetype: string): boolean {
  switch (mimetype) {
    case 'application/msword':
    case 'application/pdf':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'image/jpeg':
    case 'image/jpg':
    case 'image/png':
    case 'image/webp':
    case 'text/html':
    case 'text/plain':
      return true;
    case 'image/heic': // ='( https://github.com/docling-project/docling/issues/787
    case 'image/heif':
    default:
      return false;
  }
}
